/* Vidéos muettes : elles démarrent seules quand elles arrivent à l'écran,
   s'arrêtent quand elles en sortent, et un appui met en pause.
   Le son est forcé coupé, sauf sur les vidéos UGC « Son activable »
   quand la cliente appuie sur le haut-parleur. */
(function () {
  function brancher(v) {
    if (v.dataset.mcPret === '1') return;
    v.dataset.mcPret = '1';
    v.muted = true; v.defaultMuted = true; v.volume = 0;
    v.setAttribute('playsinline', '');
    var zone = v.closest('[data-mc-son]');
    var btn = zone && zone.querySelector('[data-mc-son-btn]');
    // Son autorisé seulement quand la cliente l'a demandé via le haut-parleur.
    v.addEventListener('volumechange', function () {
      if (!v.muted && !(zone && zone.classList.contains('is-son'))) { v.muted = true; v.volume = 0; }
    });
    function couper() {
      if (!zone) return;
      zone.classList.remove('is-son');
      v.muted = true; v.volume = 0;
      btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Activer le son');
    }
    v._mcCouper = couper;
    if (btn) btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (zone.classList.contains('is-son')) { couper(); return; }
      // un seul son à la fois
      document.querySelectorAll('[data-mc-son].is-son video').forEach(function (o) { if (o._mcCouper) o._mcCouper(); });
      zone.classList.add('is-son');
      v.muted = false; v.volume = 1;
      v.play().catch(function () {});
      btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Couper le son');
    });
    v.addEventListener('click', function () { v.paused ? v.play().catch(function () {}) : v.pause(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { v.play().catch(function () {}); }
          else { v.pause(); couper(); }
        });
      }, { threshold: 0.4 }).observe(v);
    }
  }
  function init(r) {
    (r || document).querySelectorAll('.mc-pr__ugcmedia video, video.mc-pr__ugcmedia, .mc-rout__video video, video.mc-rout__video')
      .forEach(brancher);
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  init();
  setTimeout(init, 1200);
})();
